"use strict";

require("../../style/index.less");

require("./index.less");

require("../../empty/style");

require("../../checkbox/style");

require("../../button/style");

require("../../input/style");


//////////////////
// WEBPACK FOOTER
// ../~/antd/lib/transfer/style/index.js
// module id = 485
// module chunks = 1